var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "PaymentWireTransfer",

    getDefaultProps () {
        return {"xmlns":"http://www.w3.org/2000/svg","className":"dibsvg-svg dibsvg-wire-transfer","viewBox":"0 0 500 312"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <rect width="500" height="312" fill="#F8F8F8" className="dibsvg-color-holder"/>
  <g className="dibsvg-color-letters" transform="translate(31 68)">
    <polygon points="146.083 .75 131.5 63.25 114.833 .75 104.417 .75 87.75 63.25 73.167 .75 57.542 .75 79.417 82 94 82 109.625 22.625 125.25 82 139.833 82 161.708 .75"/>
    <polygon points="182.542 82 197.125 82 197.125 .75 182.542 .75"/>
    <polygon points="310.667 82 310.667 .75 364.833 .75 364.833 13.25 325.25 13.25 325.25 35.125 363.792 35.125 363.792 47.625 325.25 47.625 325.25 69.5 364.833 69.5 364.833 82"/>
    <polygon points="15.875 172.625 15.875 127.833 .25 127.833 .25 119.5 40.875 119.5 40.875 127.833 25.25 127.833 25.25 172.625"/>
    <polygon points="209.625 172.625 182.542 135.125 182.542 172.625 173.167 172.625 173.167 119.5 182.542 119.5 208.583 157 208.583 119.5 217.958 119.5 217.958 172.625"/>
    <polygon points="290.875 172.625 290.875 119.5 327.333 119.5 327.333 127.833 300.25 127.833 300.25 141.375 326.292 141.375 326.292 149.708 300.25 149.708 300.25 172.625"/>
    <polygon points="342.958 172.625 342.958 119.5 378.375 119.5 378.375 127.833 352.333 127.833 352.333 141.375 378.375 141.375 378.375 149.708 352.333 149.708 352.333 164.292 378.375 164.292 378.375 172.625"/>
    <path d="M271.083 26.792c0-8.334-5.208-12.5-13.541-12.5h-18.75v26.041h18.75c8.333-1.041 13.541-6.25 13.541-13.541zM270.042 82l-17.709-30.208h-13.541V82H225.25V.75h34.375c15.625 0 26.042 10.417 26.042 25s-9.375 21.875-18.75 23.958l18.75 31.25L270.042 82z"/>
    <path d="M86.708 136.167c0-5.209-4.166-8.334-8.333-8.334h-12.5V144.5h12.5c5.208 0 8.333-3.125 8.333-8.333zm-1.041 36.458l-11.459-19.792h-8.333v19.792H56.5V119.5h22.917c10.416 0 16.666 7.292 16.666 16.667 0 9.375-6.25 14.583-12.5 15.625l12.5 20.833H85.667zm47.916-43.75l-9.375 25h18.75l-9.375-25zm15.625 43.75l-4.166-10.417h-23.959l-4.166 10.417H106.5l20.833-53.125h11.459l20.833 53.125h-10.417z"/>
    <path d="M233.583 165.333l5.209-7.291c3.125 4.166 9.375 7.291 16.666 7.291 7.292 0 10.417-4.166 10.417-7.291 0-11.459-30.208-4.167-30.208-23.959 0-9.375 7.291-15.625 18.75-15.625 8.333 0 14.583 3.125 19.791 7.292L269 133.042c-4.167-4.167-9.375-6.25-14.583-6.25-5.209 0-8.334 3.125-8.334 6.25 0 10.416 30.209 4.166 30.209 23.958 0 9.375-6.25 16.667-19.792 16.667-11.458 0-17.708-3.125-22.917-8.334"/>
    <path d="M426.292 136.167c0-5.209-4.167-8.334-8.334-8.334h-12.5V144.5h11.459c5.208 0 9.375-3.125 9.375-8.333zm-1.042 36.458l-11.458-19.792h-9.375v19.792h-8.334V119.5H419c10.417 0 16.667 7.292 16.667 16.667 0 9.375-6.25 14.583-12.5 15.625l12.5 20.833H425.25z"/>
  </g>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/payment-wire-transfer.svg